import React from "react"
import { useTranslation } from "react-i18next"
import { Typography } from "@mui/material"
import { dateWithTime } from "src/utils/dateHelper"

interface Props {
  dueDate: string
}

const Deadline = ({ dueDate }: Props) => {
  const { t } = useTranslation('common')
  return (<Typography variant="body2">{t('files.details.deadline')}: {dateWithTime(dueDate)}</Typography>
  )
}

export default Deadline